import React from 'react';

const GulfWarServiceDescription = (
  <ul>
    <li>Afghanistan</li>
    <li>Bahrain</li>
    <li>Djibouti</li>
    <li>Egypt</li>
    <li>Iraq</li>
    <li>Jordan</li>
    <li>Kuwait</li>
    <li>Lebanon</li>
    <li>Oman</li>
    <li>Qatar</li>
    <li>Saudi Arabia</li>
    <li>Somalia</li>
    <li>Syria</li>
    <li>The United Arab Emirates (UAE)</li>
    <li>Uzbekistan</li>
    <li>Yemen</li>
    <li>
      The waters of the Arabian Sea, Gulf of Aden, Gulf of Oman, Persian Gulf,
      or Red Sea
    </li>
    <li>The air space above any of these locations</li>
  </ul>
);

export default GulfWarServiceDescription;
